import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-pulses-help-modal',
  templateUrl: './pulses-help-modal.component.pug',
  styleUrls: ['./pulses-help-modal.component.scss'],
  standalone: false
})
export class PulsesHelpModalComponent implements OnInit {
  constructor(
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }

}
